
import * as React from "react";
import { ISetUrl } from "../../AppMain";
import Header from "../Header";
import Footer from "../Footer";
import { Checkbox } from "../../../avernus/checkbox/source/Checkbox";
import { Api } from "../../lib/Api";
import AddressBox from "../global/AddressBox";
import RunOnce from "../../../avernus/runonce/source/RunOnce";
import { Lng } from "../../../languages/Languages";
import { Url } from "../../../avernus/url/source/Url";
import RegCheckboxes from "../global/RegCheckboxes";
import { Order } from "./Order";
import ImageUpload from "../global/ImageUpload";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

interface IProfileProps {
    setUrl:ISetUrl
}

interface IInitResult{
    success             : string
    error               : string
    form                : IFormForSave
    countryOptions      : Array<IOption>
}

interface IForm{
    password                            ?: string
    email                               : string
    phone                               : string
    lastName                            : string
    firstName                           : string
    termsAndConditionsAccepted          : number
    privacyPolicyAccepted               : number
    aszfAccepted                        : number
    adattovabbitasiNyilatkozatAccepted  : number
    new_password                       ?: string
    confirm_password                   ?: string
    addressCountry                      : string
    addressState                        : string
    addressCity                         : string
    addressZip                          : string
    addressStreet                       : string
    photo                               : any
    photos                              : any
    upload_profile_photo                : any
}
interface IFormForSave{
    email                    : string
    lastName                 : string
    firstName                : string
    new_password            ?: string
    confirm_password        ?: string
    addressCountry           : string
    addressState             : string
    addressCity              : string
    addressZip               : string
    addressStreet            : string
    photo                    : any
    upload_profile_photo     : any
}

interface IOption{
    label: string
    value: number
}

interface ISaveForm{
    id      ?: number
    success  : string
    error    : string
}

interface IProfileState {
    loading             : boolean
    saving             : boolean
    success             : string
    error               : string
    form                : IForm
    countryOptions      :any

}

export default class Profile extends React.Component<IProfileProps, IProfileState>{


    constructor(props:IProfileProps){
        super(props);

        this.state = {
            success                 : null,
            error                   : null,
            form                    : null,
            loading                 : true,
            saving                  : false,
            countryOptions          : []
        };
        this.init();
    }

    init() {
        Api.call('/user/profile/get', {}, (result:IInitResult)=>{
            let form:any  = result.form as any;
            let countryOptions = result.countryOptions;
            console.log(form);
            this.setState({
                form       : form,
                countryOptions: countryOptions,
                loading    : false
            });

        });
    }

    private changeInputHandler(evt, type:string, value?:string|number): void {
        let form = this.state.form;
        if ( evt !== undefined) {
            evt.preventDefault();
            form[type] = evt.target.value;
        }else{
            form[type] = value;
        }
        this.setState({
            form: form
        });
    }



    private submitHandler(evt, saveWithPassword:boolean=false): void {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        this.setState({
            saving: true
        }, () =>{
            let saveData:IFormForSave            = this.state.form as any;
            Api.call('/user/profile/save', saveData, (result:ISaveForm)=>{
                this.setState({
                    success:        result.success,
                    error:          result.error,
                    saving:        false
                });
            });
        });
    }

    private savePhoto(file){
        let form = this.state.form;
        form['upload_profile_photo'] = file;
        this.setState({
            form: form
        });

        console.log(form);
    }


    render() {

        return (
            <div className="user_profile_page">
                <Header
                    setUrl={this.props.setUrl}
                    title={Lng.get('profile')}
                ></Header>
                <section className="content_section container">
                    <div className={"h1_box"}>
                        <h1>
                            {Lng.get('profile')}
                        </h1>
                    </div>
                    { this.state.loading === true? <LoaderComp show={true} /> :<>
                        <div className="content default_data_row">
                            <div className="form-row">
                              <div className="col">
                                  <ImageUpload label={'Upload your profile photo'} id={'upload_profile_photo'} icon={'/img/upload_photo_icon.png'} change={(file) => this.savePhoto(file)} value={this.state.form.photos['profilePhoto']} />
                              </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" name="firstName" value={this.state.form.firstName} onChange={ e => this.changeInputHandler(e,'firstName') } placeholder={Lng.get('userreg_firstname')} required={true}/>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" value={this.state.form.lastName} onChange={ e => this.changeInputHandler(e,'lastName') }
                                            name="lastName" placeholder={Lng.get('userreg_lastname')} required={true} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="email" placeholder="E-mail" name="email" value={this.state.form.email} onChange={ e => this.changeInputHandler(e,'email') } />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col">
                                    <input className="s-form-control" type="text" placeholder="Phone" name="phone" value={this.state.form.phone} onChange={ e => this.changeInputHandler(e,'phone') } />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col-12">
                                    <input className="s-form-control" type="password" minLength={8} placeholder={Lng.get('userreg_password')}
                                    name="new_password" onChange={ e => {
                                        this.changeInputHandler(e,'new_password');
                                    } } />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col-12">
                                    <input className="s-form-control" type="password" minLength={8} placeholder={"Confirm Password"}
                                           name="confirm_password" onChange={ e => {
                                        this.changeInputHandler(e,'confirm_password');
                                    } } />
                                </div>
                            </div>

                        </div>

                        <div className="content othe_data_row">
                            <AddressBox
                                key={'address_box_home_city'}
                                countryOptions={this.state.countryOptions}
                                addressCountry={this.state.form.addressCountry}
                                addressState={this.state.form.addressState}
                                addressCity={this.state.form.addressCity}
                                addressStreet={this.state.form.addressStreet}
                                addressZip={this.state.form.addressZip}
                                longitude={''}
                                latitude={''}

                                changed={ (ret) => {
                                    let form            = this.state.form;
                                    form.addressCountry = ret.addressCountry;
                                    form.addressState   = ret.addressState;
                                    form.addressCity    = ret.addressCity;
                                    form.addressStreet  = ret.addressStreet;
                                    form.addressZip     = ret.addressZip;
                                    this.setState({
                                        form: form
                                    });
                                } }
                            />


                        </div>

                        <div className="content othe_data_row">

                            <RegCheckboxes
                                privacyPolicyAccepted={this.state.form.privacyPolicyAccepted}
                                aszfAccepted={this.state.form.aszfAccepted}
                                adattovabbitasiNyilatkozatAccepted={this.state.form.adattovabbitasiNyilatkozatAccepted}
                                setUrl={this.props.setUrl}
                                changed={(acceptedAll, form)=>{
                                    let newform                                 = this.state.form;
                                    newform.privacyPolicyAccepted               = form.privacyPolicyAccepted;
                                    newform.aszfAccepted                        = form.aszfAccepted;
                                    newform.adattovabbitasiNyilatkozatAccepted  = form.adattovabbitasiNyilatkozatAccepted;
                                    this.setState({
                                        form: newform
                                    }, ()=>{
                                        new RunOnce.run(()=>{
                                            this.submitHandler(null);
                                        });
                                    });
                                }}
                            ></RegCheckboxes>

                            <br />
                            <br />
                            { this.state.success!==null?<div className="alert alert-success">
                                {Lng.get(this.state.success)}
                            </div>:'' }

                            { this.state.saving === true ?<button type="submit" className="purple_btn" disabled={true}>{Lng.get('user_profile_saving')}</button>:<button type="submit" className="purple_btn" onClick={ e => this.submitHandler(e) }
                            >{Lng.get('user_profile_done')}</button> }




                        </div>


                    </> }


                </section>
                <Footer setUrl={this.props.setUrl}></Footer>
			</div>
        );
    }


}
